<template
  >
    <div class="tr-step6C">
      <div class="tr-step6C__card">
        <div class="tr-step6C__mainHead">STEP:6(C) RETV Calculation</div>
        <div class="tr-step6C__subHead">Calculation of Term - III</div>
    <div >

        <div >
          <v-expansion-panels focusable>
            <v-expansion-panel v-for="(item, i) in step6C" :key="i" :style="{ margin: '4px' }">
              <v-expansion-panel-header><div class="accordian__header--6C">
                <v-icon left>{{ item.icon }}</v-icon>
                {{ item.name }}
              </div></v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="step6C__accordian-fields-wrap">
                  <div class="step6C__accordian-fields-row">
                    <!--Wall Surface Area Table -->
                    <div v-if="item.name === 'Windows'">
                      <RetvWindowTable6C />
                    </div>
                    <div v-else-if="item.name === 'Ventilators'">
                      <RetvVentilatorTable6C />
                    </div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
        <hr />
        <div class="step6C__summary">
          <div class="summary-head">Summary:</div>
          <div class="summary-block__wrap">
          <v-alert text dense color="teal" border="left">
     
            <div class="summary-field__row"  style="margin-bottom: 8px" >

              <div class="sumarry-field__label">
                <v-icon color="teal">mdi-sigma</v-icon>
                
                Term-III total:</div>
              <div class="summary-field__value">{{calcTerm3Total}}</div>
            </div>
          </v-alert>
          </div>
        </div>
        <hr />
        <div class="step6C-conclusion-wrap">
          <div class="step6C-conclusion-head">Conclusion:</div>
                     <v-alert 
      outlined
      text
      dense
      type="warning"
      border="left"
      icon="mdi-desktop-classic"
    >
          <div class="step6C-retv-conclusion" style="margin-bottom: 8px" :style="{ 'background-color': `#fff` }">RETV Value is {{retv6C.retv }}</div>
                </v-alert>

          <div class="step6C-retv-conclusion">
            <v-alert  text dense type="success"  v-if="retv6C.retv < 15 && retv6C.retv !==0"
            >
            
            The project complies with the ECBC-R requirement of RETV value < 15 W/m2
            </v-alert>
            <v-alert text dense type="error" v-else-if="retv6C.retv >15 || retv6C.retv== 0">
            The project does not complies with the ECBC-R requirement of RETV value > 15 W/m2

            </v-alert>
            </div>
        </div>
        <div class="step6C__next-back-row">
          <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Retv6B' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
          <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Result' })">Submit <v-icon right> mdi-airplane-takeoff </v-icon> </v-btn>
        </div>
      </div>
    </div>
      </div>
    <!-- ***** -->
    
  </div>
</template>

<script>
import RetvWindowTable6C from '../tables/retv6C/RetvWindowTable6C.vue';
import RetvVentilatorTable6C from '../tables/retv6C/RetvVentilatorTable6C.vue';
import Shgc from "@/components/shgc/Shgc.vue";
// import ShadingDialog from "@/components/shgc/ShadingDialog.vue";

export default {
  components: {
    RetvWindowTable6C,
    RetvVentilatorTable6C,
    Shgc,
    // ShadingDialog
  },
  data() {
    return {
      step6C: [{ name: 'Windows', icon: 'mdi-window-closed-variant' },
        { name: 'Ventilators', icon: 'mdi-hvac' },],
        shadingScreen:false,
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step3C: {
      get: function() {
        return this.$store.state.schema.inputs.step3C;
      },
      set: function(step3B) {
        this.$store.dispatch('setStep3C', step3C);
      },
    },
    step3A: {
      get: function() {
        return this.$store.state.schema.inputs.step3A;
      },
      set: function(step3A) {
        this.$store.dispatch('setStep3A', step3A);
      },
    },
    retv6A: {
      get: function() {
        return this.$store.state.schema.inputs.retv6A;
      },
      set: function(retv6A) {
        this.$store.dispatch('setRetv6C', retv6A);
      },
    },
    retv6B: {
      get: function() {
        return this.$store.state.schema.inputs.retv6B;
      },
      set: function(retv6B) {
        this.$store.dispatch('setRetv6C', retv6B);
      },
    },
    retv6C: {
      get: function() {
        return this.$store.state.schema.inputs.retv6C;
      },
      set: function(retv6C) {
        this.$store.dispatch('setRetv6C', retv6C);
      },
    },
    calcTerm3Total(){
      this.retv6C.term_3_total=+(+this.retv6C.total_abc_window + +this.retv6C.total_abc_ventilator).toFixed(2);
      console.log("Term 3 total",this.retv6C.term_3_total);
      if(this.retv6C.term_3_total!==0){
this.retv6C.retv=+(Number(1/this.step3A.summary.total_wall_surface_area)*(Number(6.06 * +this.retv6A.summary_retv6A.term_1_total)+Number(1.85* +this.retv6B.summary_retv6B.term_2_total)+Number(+68.99*+this.retv6C.term_3_total))).toFixed(2);
      }
    // console.log("2nd",Number(1.85* +this.retv6B.summary_retv6B.term_2_total));
    console.log("RETV",this.retv6C.retv);
    return this.retv6C.term_3_total;
    },
//     calcRETV(){
// this.retv6C.retv=(+(1/this.step3A.summary.total_wall_surface_area)*((6.06*this.retv6A.summary_retv6A.term_1_total)+(1.85*this.retv6B.term_2_total)+(68.99*this.retv6C.term_3_total))).toFixed(2);
//    return this.retv6C.retv;
//    }
  },
};
</script>

<style lang="scss">
.tr-step6C {
  padding: 16px;
  width: 100%;
  height: 100%;
}

.tr-step6C__card {
  background-color: #fff;
  padding: 20px;
  // width: 80%;
  margin: 44px 0px;

}
.tr-step6C__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step6C__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}

.accordian__header--6C {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.step6C__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step6C__next-back-row {
  padding: 16px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}
.step6C-conclusion-wrap {
  padding: 8px;
  .step6C-conclusion-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
    margin: 0px 0px 8px 0px;
  }
}
.step4-wfrop-conclusion {
  // background-color: #b3f5db;
}

// *********************

</style>
